module.exports = __webpack_public_path__ + "img/16l003-09.507b09cc.png";